import { render, staticRenderFns } from "./BaseInfoForm.vue?vue&type=template&id=8dd588ba&"
import script from "./BaseInfoForm.vue?vue&type=script&lang=js&"
export * from "./BaseInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports